import { render } from "./CasualDetails.vue?vue&type=template&id=585e5385"
import script from "./CasualDetails.vue?vue&type=script&lang=js"
export * from "./CasualDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__